import { css } from '@emotion/react';
import { motion, type AnimationScope } from 'motion/react';
import { WeavePopNotification } from '@frontend/types';
import { theme } from '@frontend/theme';
import { useNotificationPersonalizationMap } from '../notification-personalization/notification-personalization';

export type ProgressBarProps = {
  scope: AnimationScope<any>;
  type: WeavePopNotification['type'];
};

export const NotificationProgressBarNew = ({ scope, type }: ProgressBarProps) => {
  const notificationPersonalizationMap = useNotificationPersonalizationMap();
  const { color } = notificationPersonalizationMap(type);
  return (
    <div
      data-testid='new-notifications-progress-bar'
      css={css`
        bottom: 1px;
        position: absolute;
        left: 1px;
        right: 1px;
        border-bottom-left-radius: ${theme.borderRadius.medium};
        border-bottom-right-radius: ${theme.borderRadius.medium};
        overflow: hidden;
        height: 4px;
        z-index: 50;
      `}
    >
      <motion.div
        ref={scope}
        css={css`
          position: absolute;
          left: 0;
          bottom: 0;
          background: ${color.progress};
          height: 100%;
          width: 100%;
          transform-origin: left;
        `}
        initial={{ scaleX: 1 }}
      />
    </div>
  );
};

export const NotificationProgressBar = ({ scope }: ProgressBarProps) => (
  <div
    css={css`
      bottom: 0;
      position: absolute;
      left: 0;
      right: 0;
      border-bottom-left-radius: ${theme.borderRadius.medium};
      border-bottom-right-radius: ${theme.borderRadius.medium};
      overflow: hidden;
      height: 4px;
      z-index: 50;
    `}
  >
    <motion.div
      ref={scope}
      css={css`
        position: absolute;
        left: 0;
        bottom: 0;
        background: ${theme.colors.primary50};
        height: 100%;
        width: 100%;
        transform-origin: left;
      `}
      initial={{ scaleX: 1 }}
    />
  </div>
);
